import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    ordenesTrabajosInternas: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    articulo: null,
    proveedor: null,
    incluirAnulados: false,
    sortByDescending: true,
};

const mutations = {
    updateField,

    'INICIALIZAR_ORDENES' (state) {
        state.ordenesTrabajosInternas = [];
    },
    'SET_ORDENES' (state, ordenesTrabajosInternas) {
        state.ordenesTrabajosInternas = ordenesTrabajosInternas;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    getOrdenes ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDENES');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&sortByDescending='+ state.sortByDescending;
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.proveedor) {
                if (state.proveedor.id != 0) {
                    queryString += '&proveedorId=' + state.proveedor.id;
                }
            }
            if (state.incluirAnulados) {
                queryString += '&incluirAnulados=true';
            }
            
            apiAxios.get('ordenestrabajosinternas' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_ORDENES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    delete ( {}, ordenTrabajoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('ordenestrabajosinternas/' + ordenTrabajoId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}